import React, { useState, useEffect } from "react";
import SubmitRequestIcon from "../assets/directbox-default.svg";
import CustomSolutionIcon from "../assets/setting-4.svg";
import HandleLogisticsIcon from "../assets/group.svg";
import TrackUpdatesIcon from "../assets/global-search.svg";
import GrowConfidenceIcon from "../assets/chart-square.svg";

const HowItWorks: React.FC = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 620);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 620);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const steps = [
    {
      id: 1,
      icon: SubmitRequestIcon,
      title: "Submit A Request",
      description:
        "Tell us what you need whether it's freight transport, export handling, or warehousing. Just fill out our simple estimate form or speak with our team.",
    },
    {
      id: 2,
      icon: CustomSolutionIcon,
      title: "Get A Custom Solution",
      description:
        "We assess your logistics needs and design a tailored plan. You'll get transparent pricing, expected timelines, and expert guidance from start to finish.",
    },
    {
      id: 3,
      icon: HandleLogisticsIcon,
      title: "We Handle The Logistics",
      description:
        "From pickup to delivery (or port export), we take care of the entire process using our trusted fleet, warehousing facilities, and export channels.",
    },
    {
      id: 4,
      icon: TrackUpdatesIcon,
      title: "Track & Receive Updates",
      description:
        "Stay in the loop with regular updates at every stage from shipment progress to delivery confirmations and export clearance.",
    },
    {
      id: 5,
      icon: GrowConfidenceIcon,
      title: "Grow With Confidence",
      description:
        "Focus on your business while we handle the movement of goods. Our goal is to make logistics one less thing for you to worry about.",
    },
  ];

  return (
    <section
      id="how-it-works"
      style={{
        paddingTop: isMobile ? "96px" : "140px",
        paddingLeft: isMobile ? "16px" : "64px",
        paddingRight: isMobile ? "16px" : "64px",
        backgroundColor: "#ffffff",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <div
          style={{
            marginBottom: "48px",
            textAlign: "center",
          }}
        >
          <h2
            style={{
              fontSize: isMobile ? "28px" : "36px",
              fontWeight: "bold",
              color: "#1a365d",
              lineHeight: "1.3",
              margin: "0",
              maxWidth: isMobile ? "100%" : "900px",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            Simple Steps To Move Your Goods, Grow Your Business, And Reach New
            Markets.
          </h2>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: isMobile
              ? "1fr"
              : "repeat(auto-fit, minmax(300px, 1fr))",
            gap: isMobile ? "48px" : "60px",
            alignItems: "start",
          }}
        >
          {steps.map((step) => (
            <div
              key={step.id}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                textAlign: "left",
              }}
            >
              <div
                style={{
                  width: "40px",
                  height: "40px",
                  marginBottom: "24px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={step.icon}
                  alt={`${step.title} icon`}
                  style={{
                    width: "40px",
                    height: "40px",
                    objectFit: "contain",
                  }}
                />
              </div>

              <h3
                style={{
                  fontSize: isMobile ? "20px" : "24px",
                  fontWeight: "medium",
                  color: "#1a365d",
                  lineHeight: "1.3",
                  margin: "0 0 12px 0",
                }}
              >
                {step.title}
              </h3>

              <p
                style={{
                  fontSize: isMobile ? "14px" : "16px",
                  color: "#4a5568",
                  opacity: "0.76",
                  lineHeight: "1.6",
                  margin: "0",
                }}
              >
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
